@file:OptIn(InternalResourceApi::class)

package dungeonamigo.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/dungeonamigo.shared.generated.resources/"

@delegate:ResourceContentHash(819_931_648)
internal val Res.font.pixelify_sans_bold: FontResource by lazy {
      FontResource("font:pixelify_sans_bold", setOf(
        ResourceItem(setOf(), "${MD}font/pixelify_sans_bold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_843_979_835)
internal val Res.font.pixelify_sans_regular: FontResource by lazy {
      FontResource("font:pixelify_sans_regular", setOf(
        ResourceItem(setOf(), "${MD}font/pixelify_sans_regular.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(15_750_379)
internal val Res.font.silkscreen_bold: FontResource by lazy {
      FontResource("font:silkscreen_bold", setOf(
        ResourceItem(setOf(), "${MD}font/silkscreen_bold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_549_486_650)
internal val Res.font.silkscreen_regular: FontResource by lazy {
      FontResource("font:silkscreen_regular", setOf(
        ResourceItem(setOf(), "${MD}font/silkscreen_regular.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("pixelify_sans_bold", Res.font.pixelify_sans_bold)
  map.put("pixelify_sans_regular", Res.font.pixelify_sans_regular)
  map.put("silkscreen_bold", Res.font.silkscreen_bold)
  map.put("silkscreen_regular", Res.font.silkscreen_regular)
}
